<script setup lang="ts">
import { provide, ref } from "vue";
import { locale } from "../../locale";
import ToolTip from "../ToolTip.vue";
const btn = ref<HTMLElement | null>(null);
const opened = ref(false);
provide("opened", opened);
</script>
<template>
  <button ref="btn" class="settings-button">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.85" fill-rule="evenodd" clip-rule="evenodd"
        d="M19.2002 13.5C18.3718 13.5 17.7002 12.8284 17.7002 12C17.7002 11.1716 18.3718 10.5 19.2002 10.5C20.0286 10.5 20.7002 11.1716 20.7002 12C20.7002 12.8284 20.0286 13.5 19.2002 13.5ZM12.0002 13.5C11.1718 13.5 10.5002 12.8284 10.5002 12C10.5002 11.1716 11.1718 10.5 12.0002 10.5C12.8286 10.5 13.5002 11.1716 13.5002 12C13.5002 12.8284 12.8286 13.5 12.0002 13.5ZM3.30019 12C3.30019 12.8284 3.97177 13.5 4.80019 13.5C5.62862 13.5 6.30019 12.8284 6.30019 12C6.30019 11.1716 5.62862 10.5 4.80019 10.5C3.97177 10.5 3.30019 11.1716 3.30019 12Z"
        fill="#292929" />
    </svg>
    <ToolTip v-if="!opened" :placement="'top'" :reference="btn">{{
      locale.more
      }}</ToolTip>
  </button>
</template>
<style scoped>
.settings-button {
  width: 36px;
  height: 36px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background-color: rgba(236, 236, 236, 0.85);
  border-radius: 50px;
  border: none;
  cursor: pointer;
}

.settings-button:hover {
  background-color: #f6f6f6;
}

.settings-button:active {
  background-color: #dbdbdb;
}

.settings-button:focus {
  outline: none;
}
</style>
